import { openModal } from "action/modal/openModal";
import FlexitiLogo from "component/logo/FlexitiLogo";
import SezzleLogo from "component/logo/SezzleLogo";
import { widgetConfig } from "constant/bnpl-constant";
import withSession from "hoc/withSession";
import { RootState } from "interfaces/generics.type";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { currency } from "util/helper/currency";
import { getFlexitiInstallment } from "util/helper/getFlexitiInstallment";
import isFeatureEnabled from "util/helper/isFeatureEnabled";
import { parseDollarAmt } from "util/helper/parseDollarAmt";
import PAText from "../typography/PAText/PAText";
import AffirmPriceWidget from "./AffirmPriceWidget";
import styles from "./sezzle-widget.module.scss";

function SezzleWidget(props: any) {
  const {
    price = 0, className = "", style,
  } = props;
  // Show minimum price among sezzle, flexiti.
  const eachPayment = Math.min(price / 4, getFlexitiInstallment(price));
  const shouldRender = parseDollarAmt(price) >= widgetConfig.minPrice;
  const dispatch = useDispatch();
  const router = useRouter();
  const { locale } = router;
  const { t } = useTranslation("common");

  const auth = useSelector((state: RootState) => state.authenticationState);
  const { expConfigurations } = auth;
  const isAffirmEnabled = isFeatureEnabled(expConfigurations, "affirm");

  function onSezzleInfoClick() {
    dispatch(openModal("sezzle-modal", {}));
  }

  function onFlexitiInfoClick() {
    dispatch(openModal("flexiti-modal"));
  }

  if (!shouldRender && !className.includes("show")) {
    return null;
  }

  return (
    <div className={`${styles.bnpl_wrapper} ${className}`} style={style}>
      <HideIf show={isAffirmEnabled && price <= 1500000}>
        <AffirmPriceWidget amount={price} />
      </HideIf>
      <HideIf show={!isAffirmEnabled}>
        <div className={styles.bnpl_container}>
          <div className={styles.bnpl_text}>
            <PAText component="span" className="m-r-5" color="grey">{`${t("s_bnpl_payment_1")}*`}</PAText>
            <HideIf show={price !== 0}>
              <PAText component="span" color="grey">{t("starting at")}</PAText>
              <b className="p-l-5 p-r-5" style={{ color: "black", fontSize: "calc(1.8 * var(--safari-root-font, 10px))" }}>
                {currency(eachPayment, locale)}
              </b>
            </HideIf>

            <PAText component="span" className="m-r-5" color="grey">{t("s_bnpl_payment_2")}</PAText>
          </div>
          <span className={styles.inline_image}>
            <SezzleLogo />
          </span>

          <i className={`fa fa-info-circle more-info ${styles.info_icon}`} onClick={onSezzleInfoClick} />
          <PAText className={`${styles.bnpl_text} m-l-10 m-r-5`} color="grey">{t("or")}</PAText>
          <span className={styles.inline_image}>
            <FlexitiLogo />
          </span>
          <i className={`fa fa-info-circle more-info ${styles.info_icon}`} onClick={onFlexitiInfoClick} />
        </div>
      </HideIf>

    </div>
  );
}

export default withSession(SezzleWidget);
